import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "style-guide--forms-and-inputs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Checkboxes", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Radios", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Toggles / Switches", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Sliders", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Box Inputs", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "Extra Small", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "Small", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "Medium", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "label-start" }, "Label", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "label-end" }, "Side label", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "label-start" }, "Label", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label-end" }, "Side label", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "Large", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "label-start" }, "Label", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "label-end" }, "Side label", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "label-start" }, "Label", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "label-end" }, "Side label", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "Segmented Controls", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "note mb-6" }, [
  /*#__PURE__*/_createTextVNode(" The grey/white version of this component found in the calculator is "),
  /*#__PURE__*/_createElementVNode("strong", null, "deprecated"),
  /*#__PURE__*/_createTextVNode(". Do not use the grey/white version, but instead replace with this updated green/white version. ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Logic Selectors", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("code", null, ".logic-selector", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 mb-4" }, [
  /*#__PURE__*/_createTextVNode(" Use the "),
  /*#__PURE__*/_createElementVNode("strong", null, "logic-selector"),
  /*#__PURE__*/_createTextVNode(" class to properly format \"label\" text above a Logic Selector component ")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "logic-selector-label" }, "Logic Selector Label", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", null, "Box Selectors", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, "Text Fields", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", null, "Selects", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", null, "Textareas", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", null, " ", -1)
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = { class: "mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(_component_v_checkbox, {
              "model-value": false,
              label: "Unchecked"
            }),
            _createVNode(_component_v_checkbox, {
              "model-value": true,
              label: "Checked"
            }),
            _createVNode(_component_v_checkbox, {
              "model-value": false,
              label: "Disabled [Unchecked]",
              disabled: ""
            }),
            _createVNode(_component_v_checkbox, {
              "model-value": true,
              label: "Disabled [Checked]",
              disabled: ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_v_radio_group, {
              modelValue: _ctx.radios,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radios) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  label: "Option 01 [Selected by default]",
                  value: "one"
                }),
                _createVNode(_component_v_radio, {
                  label: "Option 02",
                  value: "two"
                }),
                _createVNode(_component_v_radio, {
                  label: "Option 03",
                  value: "three"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_radio_group, {
              modelValue: _ctx.disabledRadios,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.disabledRadios) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio, {
                  label: "Option 04 [Disabled, Unselected]",
                  value: "four",
                  disabled: ""
                }),
                _createVNode(_component_v_radio, {
                  label: "Option 05 [Disabled, Selected]",
                  value: "five",
                  disabled: ""
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_v_switch, { label: "Default" }),
            _createVNode(_component_v_switch, {
              label: "Selected",
              "model-value": true
            }),
            _createVNode(_component_v_switch, {
              label: "Disabled",
              disabled: ""
            }),
            _createVNode(_component_v_switch, {
              label: "Disabled [Selected]",
              "model-value": true,
              disabled: ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_v_slider, {
              modelValue: _ctx.slider,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.slider) = $event)),
              strict: ""
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Lower Bound")
                  ]),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Upper Bound")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_range_slider, {
              modelValue: _ctx.sliderRange,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sliderRange) = $event)),
              strict: ""
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Lower Bound")
                  ]),
                  _: 1
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_v_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Upper Bound")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.boxInputXs,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.boxInputXs) = $event)),
                      class: "box-input box-input-xs"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.boxInputSm,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.boxInputSm) = $event)),
                      class: "box-input box-input-sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.boxInputMd,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.boxInputMd) = $event)),
                      class: "box-input box-input-md"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _hoisted_10,
                            _hoisted_11
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            _hoisted_13
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.boxInputLg,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.boxInputLg) = $event)),
                      class: "box-input box-input-lg"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _hoisted_15,
                            _hoisted_16
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _hoisted_17,
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "ma-0",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.segmentedControl,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.segmentedControl) = $event)),
                      class: "segmented-control"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    _hoisted_24,
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.toggleOne,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.toggleOne) = $event)),
                      class: "logic-selector"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("one")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("two")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("three")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("four")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("five")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "mb-8"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_toggle, {
                      modelValue: _ctx.boxSelector,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.boxSelector) = $event)),
                      class: "box-selector"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Label")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_26,
            _createVNode(_component_v_text_field, {
              rules: [_ctx.rules.required],
              label: "First name"
            }, null, 8, ["rules"]),
            _createVNode(_component_v_text_field, {
              rules: [_ctx.rules.required],
              label: "Last name"
            }, null, 8, ["rules"]),
            _createVNode(_component_v_text_field, {
              label: "Email address",
              placeholder: "johndoe@gmail.com",
              type: "email"
            }),
            _createVNode(_component_v_text_field, {
              label: "Disabled Input",
              "model-value": "Filled out",
              disabled: ""
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_27,
            _createVNode(_component_v_select, {
              label: "Select a number",
              items: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
              rules: [_ctx.rules.required]
            }, null, 8, ["rules"]),
            _createVNode(_component_v_select, {
              label: "State",
              items: ['California', 'Colorado', 'Florida', 'Georgia', 'Texas', 'Wyoming'],
              rules: [_ctx.rules.required]
            }, null, 8, ["rules"]),
            _createVNode(_component_v_select, {
              label: "Disabled Select",
              items: ['California', 'Colorado', 'Florida', 'Georgia', 'Texas', 'Wyoming'],
              disabled: ""
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_28,
            _createVNode(_component_v_textarea, {
              label: "Please provide your comments",
              class: "mb-4"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_v_textarea, {
                rules: [_ctx.rules.required],
                label: "This textarea is required",
                "model-value": "This is pre-filled"
              }, null, 8, ["rules"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_v_textarea, {
                rules: [_ctx.rules.required],
                label: "This textarea is required"
              }, null, 8, ["rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}